import Layout from "./Cpanel/pages/AdminLayout";
import "./Assets/Styles/bootstrap.rtl.min.css";
import "./Assets/fonts/fa-solid-900.woff2";
import "./Assets/fonts/iransansweb.woff2";
import "./index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import PanelAdmin from "./Cpanel/pages/PanelAdmin";
import PrivateRoutes from "./PrivateRoutes";
import Profile from "./Landing/Pages/Profile";
import Home from "./Landing/Pages/Home";
import CoworkwithTab30 from "./Landing/Pages/CoworkwithTab30";
import Referral from "./Landing/Pages/Referral";
import MyCoins from "./Landing/Components/MyCoins";
import { createContext, useEffect, useState } from "react";
import { Banners } from "./Cpanel/pages/Banners";
import { Users } from "./Cpanel/pages/Users";
import { UserDetail } from "./Cpanel/pages/UserDetail";
import { ControlSidebar } from "./Cpanel/pages/ControlSidebar";
import { Features } from "./Cpanel/pages/Features";
import { PageMaker } from "./Cpanel/pages/PageMaker";
import Shops from "./Landing/Pages/Shops";
import { UserCoins } from "./Cpanel/pages/UserCoins";
import { ControlShop } from "./Cpanel/pages/ControlShop";
import { ControlBuy } from "./Cpanel/pages/ControlBuy";
import { ControlPayment } from "./Cpanel/pages/ControlPayment";
import { ControlInsurance } from "./Cpanel/pages/ControlInsurance";
import CPanelPrivateRoutes from "./Cpanel/pages/CPanelPrivateRoutes";
import { Management } from "./Cpanel/pages/Management";
import { DisableUsers } from "./Cpanel/pages/DisableUsers";
import InsuranceTemplate from "./Landing/Insurance/InsuranceTemplate";
import InsuranceForm from "./Cpanel/pages/InsuranceForm";
import Support from "./Landing/Components/Support/Support";
import InsuranceSteps from "./Landing/Insurance/InsuranceSteps";
import Tutorial from "./Landing/Pages/Tutorial";
import MenuContentPage from "./Landing/Pages/MenuContentPage";
import { MainLayout } from "./Landing/Components/MainLayout";
import { Video } from "./Cpanel/pages/Video";
import { Category } from "./Cpanel/pages/Category";
import Subsets from "./Landing/Components/Subsets";
import { ShopCategory } from "./Cpanel/pages/ShopCategory";
import { SupportList } from "./Cpanel/pages/SupportList";
import { Fund } from "./Cpanel/pages/Fund";
import UsersTreeView from "./Cpanel/Components/UsersTreeView";
import { Plans } from "./Landing/Pages/Plans";
import ShopPanelPrivateRoute from "./ShopPanel/ShopPanelPrivateRoute";
import ShopLayout from "./ShopPanel/ShopLayout";
import AdminLayout from "./Cpanel/pages/AdminLayout";
import PanelShop from "./ShopPanel/PanelShop";
import Coin from "./ShopPanel/Coin";
import { OfflineShop } from "./ShopPanel/OfflineShop";
import Messages from "./Landing/Pages/Messages";
import { ShopCategoryControl } from "./ShopPanel/ShopCategoryControl";
import { PayList } from "./Landing/Pages/PayList";
import { SellList } from "./ShopPanel/SellList";
import { CashbackList } from "./ShopPanel/CashbackList";
import { ShopProfile } from "./Landing/Components/Shops/ShopProfile";
import { ShopProfileLocal } from "./Landing/Components/Shops/ShopProfileLocal";
import { ImportUserFromExcel } from "./Cpanel/pages/ImportUserFromExcel";
import { ShopGallery } from "./ShopPanel/ShopGallery";
import ShopCells from "./Cpanel/pages/ShopCells";
import { Returned } from "./ShopPanel/Retuerned";
import { LocalPayList } from "./ShopPanel/LocalPayList";
import InsurancePayment from "./Landing/Insurance/InsurancePayment";
import { ProductsControl } from "./Cpanel/pages/ProductsControl";
import { ProductDetail } from "./Landing/Pages/ProductDetail";
import ShopList from "./Landing/Pages/ShopList";
import UserPayList from "./Landing/Pages/UserPayList";
import BuyProduct from "./Landing/Pages/BuyProduct";
import { BuyProductForm } from "./Landing/Components/BuyProductForm";
import { CoinFund } from "./Cpanel/pages/CoinFund";
import { ShopsCategorysControl } from "./Cpanel/pages/ShopsCategoryControl";
import ReciptPage from "./Components/ReciptPage";

library.add(fas);
export const ThemeContext = createContext(null);
const value = {
  appendTo: "self",
};

function App() {
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    setTheme((curr) => (curr === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  const savedTheme = localStorage.getItem("theme");
  useEffect(() => {
    if (savedTheme) {
      setTheme(savedTheme);
    }
  }, []);

  // Save theme to local storage whenever it changes
  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div id={theme} className="">
        <Router>
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route path="/profile" element={<Profile />} />

              <Route
                path="/LifeInsurance/insurancesteps"
                element={<InsuranceSteps />}
              />
              <Route
                path="/LifeInsurance/insurancepayment"
                element={<InsurancePayment />}
              />

              <Route element={<ShopPanelPrivateRoute />}>
                <Route path="shoppanel" element={<ShopLayout />}>
                  <Route path="dashboard" element={<PanelShop />} />
                  <Route
                    path="shopCategoryControl"
                    element={<ShopCategoryControl />}
                  />
                  <Route path="paylist" element={<PayList />} />
                  <Route path="localpaylist" element={<LocalPayList />} />
                  <Route path="selllist" element={<SellList />} />
                  <Route path="cashbacklist" element={<CashbackList />} />
                  <Route path="coin" element={<Coin />} />
                  <Route path="offlineshop" element={<OfflineShop />} />
                  <Route path="shopgallery" element={<ShopGallery />} />
                  <Route path="returned" element={<Returned />} />
                  <Route path="information" element={<PanelShop />} />
                  <Route
                    path="*"
                    index
                    element={<Navigate to="/shoppanel/dashboard" />}
                  />
                </Route>
              </Route>
              <Route element={<CPanelPrivateRoutes />}>
                <Route path="cpanel" element={<AdminLayout />}>
                  <Route path="dashboard" element={<PanelAdmin />} />
                  <Route path="banners" element={<Banners />} />
                  <Route path="users" element={<Users />} />
                  <Route path="users/treeview" element={<UsersTreeView />} />
                  <Route path="disableusers" element={<DisableUsers />} />
                  <Route
                    path="addusersfromexcel"
                    element={<ImportUserFromExcel />}
                  />
                  <Route path="users/detail/:userId" element={<UserDetail />} />
                  <Route path="users/:userId" element={<UserCoins />} />
                  <Route path="sidebar" element={<ControlSidebar />} />
                  <Route path="Features" element={<Features />} />
                  <Route path="pagemaker" element={<PageMaker />} />
                  <Route path="products" element={<ProductsControl />} />
                  <Route path="shopscategory" element={<ShopsCategorysControl />} />
                  <Route path="shop" element={<ControlShop />} />
                  <Route path="shopcells" element={<ShopCells />} />
                  <Route path="insurance" element={<ControlInsurance />} />
                  <Route
                    path="insurance/:insuranceId"
                    element={<InsuranceForm />}
                  />
                  <Route path="shopbuy" element={<ControlBuy />} />
                  <Route path="pay" element={<ControlPayment />} />
                  <Route path="sell" element={<ControlPayment />} />
                  <Route path="management" element={<Management />} />
                  <Route path="video" element={<Video />} />
                  <Route path="category" element={<Category />} />
                  <Route path="shopcategory" element={<ShopCategory />} />
                  <Route path="supportList" element={<SupportList />} />
                  <Route path="fund" element={<Fund />} />
                  <Route path="coinfund" element={<CoinFund />} />
                  <Route
                    path="*"
                    //       exact
                    index
                    element={<Navigate to="/cpanel/dashboard" />}
                  />
                </Route>
              </Route>
              <Route path="/MyCoins" element={<MyCoins />} />
              <Route path="/subsets" element={<Subsets />} />
              <Route path="/messageBox" element={<Messages />} />
            </Route>
            <Route element={<MainLayout />}>
              <Route path="/خانه" element={<Home />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/shops" element={<Shops />} />
              <Route path="/shopprofile/:id" element={<ShopProfile />} />
              <Route
                path="/shopprofilelocal/:id"
                element={<ShopProfileLocal />}
              />
              <Route path="/tutorial" element={<Tutorial />} />
              <Route path="/shopList" element={<ShopList />} />
              <Route path="/userpayList" element={<UserPayList />} />
              <Route path="/LifeInsurance" element={<InsuranceTemplate />} />
              <Route path="/referral" element={<Referral />} />
              <Route path="/JoinUs" element={<CoworkwithTab30 />} />
              <Route path={"/page/:id/:title"} element={<MenuContentPage />} />
              <Route path="/support" element={<Support />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/buyproduct" element={<BuyProduct/>} />
              <Route path="/buyproductform" element={<BuyProductForm/>} />
              <Route path="/receipt" element={<ReciptPage/>} />
            </Route>
            <Route
              path="*"
              element={
                <Navigate
                  to={{
                    search: window.location.search.split("?")[1],
                    pathname: "/خانه",
                  }}
                />
              }
            />
          </Routes>
        </Router>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
